import { useEffect, useState } from "react";
import { createDateFromSeconds } from "../../helpers/createDateFromSeconds";

import "./Application.css";
import { getApplication } from "../../api/applications";
import { useParams } from "react-router-dom";
import Layout from "../layout/Layout";

import { HashLink as Link } from "react-router-hash-link";
import ForwardIcon from "@mui/icons-material/Forward";

function Application({
  loaded,
  showContact,
  setShowContact,
  showMenu,
  setShowMenu,
  currentActive,
  setCurrentActive,
}) {
  const [applicationData, setApplicationData] = useState(null);
  const params = useParams();

  useEffect(() => {
    if (params.id && applicationData === null) {
      getApplication(params.id)
        .then((res) => setApplicationData(res))
        .catch((err) => console.log(err));
    }
  }, [params, applicationData]);

  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <Layout
      loaded={loaded}
      hideContacts
      showContact={showContact}
      setShowContact={setShowContact}
      showMenu={showMenu}
      setShowMenu={setShowMenu}
      currentActive={currentActive}
      setCurrentActive={setCurrentActive}
    >
      {applicationData && (
        <>
          <div className="back-link">
            <Link to="/applications" onClick={handleClick}>
              <button className="application-button">
                <div className="application-button-arrow">
                  <ForwardIcon />
                </div>
                <span className="application-button-text">Vissza</span>
              </button>
            </Link>
          </div>

          <div className="application-wrapper">
            <div className="application">
              {applicationData.publicationDate && (
                <p className="publication-date">
                  {createDateFromSeconds(
                    applicationData.publicationDate.seconds,
                  )}
                </p>
              )}

              {applicationData.congressName && (
                <h2 className="application-title">
                  Pályázati felhívás: {applicationData.congressName}
                </h2>
              )}

              {applicationData.congressDate && applicationData.congressName && (
                <p className="application-description">
                  A Pharmacenter Hungary Kft. pályázatot hirdet a
                  <b>{` ${createDateFromSeconds(applicationData.congressDate.seconds)} `}</b>
                  dátumon, <b>{applicationData.congressName}</b> néven tartandó
                  rendezvényen történő részvétel támogatására.
                </p>
              )}

              {applicationData.applicationDeadline && (
                <p className="application-data">
                  <b>Pályázati határidő: </b>{" "}
                  {createDateFromSeconds(
                    applicationData.applicationDeadline.seconds,
                  )}
                </p>
              )}

              <p className="application-description">
                A pályázat során az alábbi adatokat kérjük megadni: a pályázó
                nevét, munkahelyét, telefonszámát, e-mail címét.
              </p>

              {applicationData.applicationEmail && (
                <p className="application-description">
                  A pályázat beadása elektronikus úton történhet, a pályázati
                  anyag az alábbi e-mail címre történő megküldésével:{" "}
                  <a href={`mailto:${applicationData.applicationEmail}`}>
                    {applicationData.applicationEmail}
                  </a>
                </p>
              )}

              <p className="application-description">
                A beérkezett pályázatokat a pályázati határidő lejártát követően
                független bíráló bizottság értékeli.
              </p>
            </div>
          </div>
        </>
      )}
    </Layout>
  );
}

export default Application;
